<template>
  <div class="mc-report__route-geolocation-time">
    <div class="mc-report__route-geolocation-time-title" v-if="render">
      <div class="d-flex flex-row">
        <h5 class="mt-2">
          {{
            selectedTab === 'tripMileage'
              ? $t('report.fields.tripMileage')
              : selectedTab === 'tripDuration'
              ? $t('report.fields.tripDuration')
              : $t('report.fields.top20FuelUsage')
          }}
        </h5>
        <b-dropdown size="sm" class="ms-2 mb-4 mt-1" right>
          <template #button-content>
            <i class="icon-fill_chevron-down m-0 p-0" size="md"></i>
          </template>
          <b-dropdown-item-button @click="changeTab('tripDuration')">{{
            $t('report.fields.tripDuration')
          }}</b-dropdown-item-button>
          <b-dropdown-item-button @click="changeTab('tripMileage')">{{
            $t('report.fields.tripMileage')
          }}</b-dropdown-item-button>
          <b-dropdown-item-button @click="changeTab('top20Fuel')">{{
            $t('report.fields.top20FuelUsage')
          }}</b-dropdown-item-button>
        </b-dropdown>
      </div>
      <div>
        <b-form-radio-group
          id="btn-radios-1"
          v-model="selected"
          :options="radioGroupOptions"
          name="radios-btn-default"
          buttons
          button-variant="outline-primary"
          class="mc-btn--toggle"
        ></b-form-radio-group>
      </div>
    </div>
    <div class="mc-report__route-geolocation-time-content" v-if="render">
      <template v-if="selected === 'tabel'">
        <div class="border border-1 table-overflow">
          <table class="table b-table table-sm">
            <thead>
              <tr>
                <th>No.</th>
                <th>{{ $t('global.object.licensePlate') }}</th>
                <th>
                  {{
                    selectedTab === 'tripMileage'
                      ? $t('report.fields.distance')
                      : selectedTab === 'tripDuration'
                      ? $t('report.fields.tripDuration')
                      : $t('report.fields.fuelUsage')
                  }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in tripsBetweenGeofences" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ data.vehicle.licensePlate }}</td>
                <td>
                  {{
                    selectedTab === 'tripMileage'
                      ? parseFloat(data.tripMileage / 1000).toFixed(2)
                      : selectedTab === 'tripDuration'
                      ? secondsToHours(data.tripDuration)
                      : data.tripFuel
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>

      <template v-else>
        <div class="mc-chart" v-if="render">
          <LineChart
            :labels="totalChartData.labels"
            :datasets="totalChartData.datasets"
            yLabel="Jam"
            ref="lineChartRef"
            :options="chartOptions"
            v-if="selectedTab === 'tripDuration'"
          />
          <HorizontalBarChart
            :labels="totalChartData.labels"
            :datasets="totalChartData.datasets"
            ref="barChartRef"
            :horizontalBarChart="true"
            :options="barChartOptions"
            v-else
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import LineChart from '@/components/Chart/Line.vue'
import HorizontalBarChart from '@/components/Chart/HorizontalBar.vue'
import { Helper } from '@/mixin/helper'

export default {
  components: { LineChart, HorizontalBarChart },

  mixins: [Helper],

  props: ['tripsBetweenGeofences', 'average'],
  data() {
    return {
      selected: 'tabel',
      loading: false,
      periodeDates: [],
      averageTotalTrip: [],
      actualTripDuration: [],
      actualTripMileage: [],
      top20Fuel: [],
      selectedTab: 'tripDuration',
      render: false,
      licensePlates: [],
    }
  },

  computed: {
    chartOptions() {
      return {
        legend: {
          position: 'bottom',
          fullWidth: false,
          labels: {
            boxWidth: 10,
          },
        },
      }
    },

    barChartOptions() {
      return {
        legend: { position: 'bottom', labels: { boxWidth: 0 } },
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: (value) => {
                  if (Number.isInteger(value)) {
                    return value
                  }
                },
              },
            },
          ],
        },
      }
    },

    radioGroupOptions() {
      return [
        {
          html: `<i class="icon-outline_browser"></i><span>${this.$t(
            'report.object.table'
          )}</span>`,
          value: 'tabel',
        },
        {
          html: `<i class="icon-outline_bar-chart-2"></i><span>${this.$t(
            'report.object.chart'
          )}</span>`,
          value: 'grafik',
        },
      ]
    },

    totalChartData() {
      let obj = {}

      if (this.selectedTab === 'tripDuration') {
        obj = {
          labels: this.periodeDates,
          datasets: [
            {
              data: this.actualTripDuration,
              label: 'Waktu Tempuh Aktual',
              fill: false,
              pointRadius: 4,
              lineTension: 0,
              borderWidth: 4,
              borderColor: '#0d4491',
            },
            {
              data: this.averageTotalTrip,
              label: 'Rata - rata Waktu Tempuh',
              backgroundColor: 'transparent',
              fill: false,
              pointRadius: 4,
              lineTension: 0,
              borderWidth: 4,
              borderColor: '#ff8a00',
            },
          ],
        }
      } else if (this.selectedTab === 'tripMileage') {
        obj = {
          labels: this.licensePlates,
          datasets: [
            {
              axis: 'y',
              data: this.actualTripMileage,
              label: this.$t('report.fields.distance'),
              backgroundColor: '#0d4491',
              borderColor: '#0d4491',
              borderWidth: 1,
              borderRadius: 5,
            },
          ],
        }
      } else if (this.selectedTab === 'top20Fuel') {
        obj = {
          labels: this.licensePlates,
          datasets: [
            {
              axis: 'y',
              data: this.top20Fuel,
              label: this.$t('report.fields.totalFuelUsage'),
              backgroundColor: '#0d4491',
              borderColor: '#0d4491',
              borderWidth: 1,
              borderRadius: 5,
            },
          ],
        }
      }

      return obj
    },
  },

  created() {
    if (this.tripsBetweenGeofences) {
      this.actualTripDuration = this.tripsBetweenGeofences.map((item) =>
        parseFloat(item.tripDuration / 3600).toFixed(2)
      )
      this.actualTripMileage = this.tripsBetweenGeofences.map((item) =>
        parseFloat(item.tripMileage / 1000).toFixed(2)
      )
      this.top20Fuel = this.tripsBetweenGeofences
        .map((item) => parseFloat(item.tripFuel).toFixed(2))
        .slice(0, 21)

      this.periodeDates = this.tripsBetweenGeofences.map((item) =>
        this.momentDateShortMonth(item.stopTime)
      )

      this.licensePlates = this.tripsBetweenGeofences.map((item) => item.vehicle.licensePlate)
    }

    if (this.average) {
      const average = parseFloat(this.average.tripDuration / 3600).toFixed(2)
      let charArray = []

      if (this.periodeDates.length > 1) {
        for (var i = 0; i < this.periodeDates.length; i++) {
          charArray.push(average)
        }
      } else if (this.periodeDates.length === 1) {
        for (var j = 0; j < 2; j++) {
          charArray.push(average)
        }
      }

      this.averageTotalTrip = charArray
    }

    this.render = true
  },

  methods: {
    changeTab(value) {
      this.render = false
      this.selectedTab = value

      setTimeout(() => {
        this.render = true
      }, 700)
    },
  },
}
</script>
